import { render, staticRenderFns } from "./InvoiceBatchCreate.vue?vue&type=template&id=70fa9372&"
import script from "./InvoiceBatchCreate.vue?vue&type=script&lang=ts&"
export * from "./InvoiceBatchCreate.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceBatchCreate.vue?vue&type=style&index=0&id=70fa9372&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports